import { OrganizationRole } from '@/enums/roles';
import ModuleContent from '@/views/modules/ModuleContent.vue';
import Modules from '@/views/modules/Modules.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/module-overzicht',
        name: 'modules',
        component: Modules,
        meta: {
            pageTitle: 'Module overzicht',
            roles: [OrganizationRole.Employee]
        }
    },
    {
        path: '/module-overzicht/:module',
        component: ModuleContent,
        name: 'module',
        meta: {
            pageTitle: 'Module',
            roles: [OrganizationRole.Employee]
        }
    }
];

export default routes;
